import React from "react";
import "./Spinner.css";

function Spinner({ style = {} }) {
	return <span className="spinner spinner-white" style={{ margin: "0 10px", ...style }}></span>;
}

export default Spinner;
